import * as ObstacleActions from '../actions/obstacles.actions';
import { ObstacleModel } from '../../models';
import { random, difference } from 'lodash';

export type Action = ObstacleActions.All;

export interface ObstaclesState {
    recentObstacles: ObstacleModel[];
    obstacles: ObstacleModel[];
    current: ObstacleModel;
    classified: ObstacleModel[];
    loading: boolean;
    error: string;
}

const defaultState: ObstaclesState = {
    recentObstacles: [],
    obstacles: [],
    current: null,
    classified: [],
    loading: false,
    error: null
};

function pickRandom(from: any[], exclude: any[]) {
    let list = difference(from, exclude);

    if (list.length === 0) {
        return 0;
    } else {
        let index = random(list.length - 1);
        return list[index];
    }
}

export const obstaclesReducer = (state: ObstaclesState = defaultState, action: Action): ObstaclesState => {
    switch (action.type) {

        case ObstacleActions.GET_OBSTACLES: {
            return {
                recentObstacles: [],
                obstacles: [],
                current: null,
                classified: [],
                loading: true,
                error: null
            };
        }

        case ObstacleActions.GET_OBSTACLES_SUCCESS: {
            let validObstacles = action.obstacles.filter(item => item.photo);
            let current = pickRandom(validObstacles, []);
            return {
                recentObstacles: [],
                obstacles: validObstacles,
                current,
                classified: [current],
                loading: false,
                error: null
            };
        }

        case ObstacleActions.GET_OBSTACLES_FAILURE: {
            return {
                recentObstacles: [],
                obstacles: [],
                current: null,
                classified: [],
                loading: false,
                error: action.error
            };
        }

        case ObstacleActions.GET_RECENT_OBSTACLES: {
          return {
              recentObstacles: [],
              obstacles: [],
              current: null,
              classified: [],
              loading: true,
              error: null
          };
        }

        case ObstacleActions.GET_RECENT_OBSTACLES_SUCCESS: {
        let validObstacles = action.recentObstacles.sort((a, b) => {
          const aDate = new Date(a.createdAt);
          const bDate = new Date(b.createdAt);

          if (aDate < bDate) {
            return 1;
          } else if (aDate > bDate) {
            return -1;
          } else { //equal
            return 0
          }
        });
            let current = pickRandom(validObstacles, []);
            return {
                recentObstacles: validObstacles,
                obstacles: [],
                current,
                classified: [current],
                loading: false,
                error: null
            };
        }

        case ObstacleActions.GET_RECENT_OBSTACLES_FAILURE: {
            return {
                recentObstacles: [],
                obstacles: [],
                current: null,
                classified: [],
                loading: false,
                error: action.error
            };
        }

        case ObstacleActions.NEXT_OBSTACLE: {
            let next = pickRandom(state.obstacles.filter(item => item.state !== 5), state.classified);
            return Object.assign({}, state, {
                current: next,
                classified: [...state.classified, next]
            });
        }

        default: {
            return state;
        }
    }
};



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/core/store/reducers/obstacles.reducer.ts